import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

import { categories } from './categories';
import './DiscoverUs.css'

const DiscoverList = () => {
  const [search, setSearch] = useState('');
  const [listening, setListening] = useState(false);
  const recognitionRef = useRef();

  // initialize speech recognition
  useEffect(() => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (SpeechRecognition) {
      const recognition = new SpeechRecognition();
      recognition.continous = false;
      recognition.interimResults = false;
      recognition.lang = 'en-US';

      recognition.onstart = () => setListening(true);
      recognition.onend = () => setListening(false);
      recognition.onerror = (e) => {
        console.error('Speech recognition error', e)
        setListening(false);
      }

      recognition.onresult = (event) => {
        let transcript = event.results[0][0].transcript;
        transcript = transcript.replace(/[.,!?]$/, '');
        setSearch(transcript);
      }
      recognitionRef.current = recognition;
    } else {
      console.warn('Speech Recognition API not supported in this browser');
    }
  }, []);

  const handleVoiceSearch = () => {
    if (!recognitionRef.current) return;

    if (listening) {
      recognitionRef.current.stop();
    } else {
      recognitionRef.current.start();
    }
  };

  const filteredCategories = categories.filter(cat =>
    cat.name.toLowerCase().includes(search.toLowerCase())
  );


  return (
    <main id="main-content" >
    <div className="container py-5">
      <div className="text-center mb-5">
        {/* <h1 className="display-5 fw-bold">🌳 Discover Us 🌳</h1> */}
        <h1 className="display-5 fw-bold d-flex justify-content-center align-items-center gap-2">
          <img
            src={`${process.env.PUBLIC_URL}/image/FUN.png`}
            alt="Discover Us Icon"
            style={{ width: '120px', height: '100px', objectFit: 'contain' }}
          />
          Discover Us
          <img
            src={`${process.env.PUBLIC_URL}/image/FUN_left.png`}
            alt="Discover Us Icon"
            style={{ width: '120px', height: '100px', objectFit: 'contain' }}
          />
        </h1>
        <p className="lead text-muted">Explore over 30,000 acres of Parks & Recreation in Prince George’s County.</p>
        <p className="text-secondary fs-5">Find your FUN — there's something here for YOU!</p>
        <div className="d-flex justify-content-center align-items-center mt-3">
          <input
            type="text"
            className="form-control w-50 rounded-end-0"
            placeholder="Search categories..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <button
            onClick={handleVoiceSearch}
            className={`btn btn-outline-success rounded-start-0 ${listening ? 'btn-danger' : ''}`}
            title="Voice Search"
          >
            {listening ? '🎤  Listening...' : '🎙️'}
          </button>
          {/* Find Parks Near me */}
          <Link
            to="/nearby?auto=true"
            className="btn btn-outline-success rounded"
            style={{ marginLeft: '5rem' }}
          >
            📍FUN Places Near You
          </Link>
        </div>

      </div>
      {/* <div className="row g-4">  -- for 6 columns */}
      <div className="category-grid"> 
        {filteredCategories.map(cat => ( 
          //  <div className="col-6 col-sm-4 col-md-3 col-lg-2"> -- for 6 columns
          <div className="category-item" key={cat.id}>
            <div
              className="card text-center h-100 shadow-sm"
              style={{ cursor: 'pointer', border: '0.5px solid #90ee90' }}
              onClick={() => window.location.href = cat.path}
            >
              <div className="card-body text-center">
                {/* <div className="display-4">  */}
                  <img src={cat.icon} 
                  alt={cat.name} 
                  className='img-fluid'
                  style={{width: '80px', height: '65px', objectFit: 'contain'}}
                  />
                  {/* </div> */}
                <h2 className="card-title mt-2 category-title">{cat.name}</h2>
                <p className="text-muted small">{cat.count === 1 ? `${cat.count} Location` : `${cat.count} Locations`} </p>
                {/* hover desc overlay */}
                {cat.description && (
                  <div className="description-overlay">
                    <small>{cat.description}</small>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
    </main>
  )

}

export default DiscoverList;